import { Popover, Grid, TextField, Button, Typography, Box, Autocomplete } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import CachedIcon from '@mui/icons-material/Cached';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import './filtrosTabela.scss';
import MaskedInput from 'components/Utils/MaskedInput';
import useFiltrosTabelaHistoricoHook from '../../hooks/useFiltrosTabelaHistoricoHook';

export default function FiltrosTabela({ onFiltrar, contadorFiltros, presetFiltros }) {
  const {
    filtros,
    open,
    id,
    anchorEl,
    handleChange,
    handleOpen,
    handleClose,
    handleLimpar,
    handleFiltrar,
    listaStatusOperacao
  } = useFiltrosTabelaHistoricoHook({ onFiltrar, presetFiltros });

  return (
    <>
      <Box>
        <Button
          aria-describedby={id}
          className="btn-filtros-cessao"
          variant="outlined"
          onClick={handleOpen}
        >
          <Box className="filtros-titulo">
            <FilterListIcon />
            {contadorFiltros > 0 && <Box className="contador-filtros">{contadorFiltros}</Box>} FILTROS
          </Box>
        </Button>

        <Button
          id="limpar-filtros"
          className="btn-filtros-cessao"
          variant="outlined"
          onClick={handleLimpar}
        >
          <Box className="filtros-titulo">
            <CachedIcon />
            LIMPAR
          </Box>
        </Button>
      </Box>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        className="componente-filtros"
        PaperProps={{ className: 'componente-filtros__paper' }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        slotProps={{
          popper: {
            modifiers: [
              { name: 'flip', enabled: false },
              { name: 'offset', options: { offset: [0, 8] } },
              { name: 'preventOverflow', options: { tether: false } }
            ]
          }
        }}
      >
        <Box className="filtros-card">
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <Grid container spacing={2}>
              <Grid item md={3} sm={6} xs={12}>
                <TextField
                  label="Nº Operação"
                  fullWidth
                  value={filtros.numero_operacao_one7}
                  onChange={e => handleChange('numero_operacao_one7', e.target.value)}
                />
              </Grid>

              <Grid item md={3} sm={6} xs={12}>
                <Autocomplete
                  options={listaStatusOperacao}
                  value={
                    listaStatusOperacao.find(
                      o => String(o.CODCESSOESCAPITALFLOWSTATUS) === String(filtros.status_cessao)
                    ) ?? null
                  }
                  onChange={(_, newValue) =>
                    handleChange('status_cessao', newValue?.CODCESSOESCAPITALFLOWSTATUS ?? '')
                  }
                  disablePortal
                  noOptionsText="Nenhum status encontrado."
                  loadingText="Carregando..."
                  clearText="Limpar"
                  isOptionEqualToValue={(option, value) =>
                    String(option?.CODCESSOESCAPITALFLOWSTATUS) ===
                    String(value?.CODCESSOESCAPITALFLOWSTATUS)
                  }
                  getOptionLabel={option => option?.DESCRICAOSTATUS ?? ''}
                  renderInput={params => <TextField {...params} label="Status" />}
                />
              </Grid>

              <Grid item md={3} sm={6} xs={12}>
                <TextField
                  label="Número do documento"
                  fullWidth
                  value={filtros.numero_documento}
                  onChange={e => handleChange('numero_documento', e.target.value)}
                />
              </Grid>

              <Grid item md={3} sm={6} xs={12} />

              <Grid item md={3} sm={6} xs={12}>
                <Typography className="label-data">Data de operação</Typography>
                <DatePicker
                  label="Início"
                  className="w-100"
                  value={filtros.data_solicitacao_de}
                  onChange={newVal => handleChange('data_solicitacao_de', newVal)}
                />
              </Grid>

              <Grid item md={3} sm={6} xs={12}>
                <DatePicker
                  label="Fim"
                  className="ajuste-input-label w-100"
                  value={filtros.data_solicitacao_ate}
                  onChange={newVal => handleChange('data_solicitacao_ate', newVal)}
                />
              </Grid>

              <Grid item md={3} sm={6} xs={12}>
                <Typography className="label-data">Valor total</Typography>
                <MaskedInput
                  label="Mínimo"
                  fullWidth
                  name="valor_de"
                  value={filtros.valor_de ?? ''}
                  onChange={e => handleChange('valor_de', e.target.value)}
                  getFormat="money"
                />
              </Grid>

              <Grid item md={3} sm={6} xs={12}>
                <MaskedInput
                  label="Máximo"
                  fullWidth
                  className="ajuste-input-label"
                  name="valor_ate"
                  value={filtros.valor_ate ?? ''}
                  onChange={e => handleChange('valor_ate', e.target.value)}
                  getFormat="money"
                />
              </Grid>
            </Grid>
          </LocalizationProvider>

          <Box className="filtros-footer">
            <Typography className="filtros-footer-text">
              Você pode aplicar novos filtros sem perder a seleção anterior
            </Typography>
            <Button variant="outlined" onClick={handleFiltrar}>
              Filtrar
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
}
